import api from "../../../Component/axios";

export const useEmpaque = () => {
  const token = localStorage.getItem("@Token");

  const getPedidoEmpaque = async (fecha, id_variedad) => {
    let variedad = ``;
    if (parseInt(id_variedad) !== 0) {
      variedad = `&id_variedad=${id_variedad}`;
    }
    try {
      const response = await api.get(
        `api/pedido-empaque/pedido_empaque/?fecha=${fecha}${variedad}`,
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  const saveEmpaque = async (data) => {
    try {
      const response = await api.post(
        "api/pedido-empaque/pedido_empaque/",
        data,
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
      return response;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  const retrivePedido = async (id) => {
    try {
      const response = await api.get(
        `api/pedido-empaque/pedido_empaque/${id}`,
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  const destroyPedido = async (id_pedido) => {
    try {
      await api.delete(`api/pedido-empaque/pedido_empaque/${id_pedido}`, {
        headers: {
          Authorization: "Token " + token,
        },
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  const editPedido = async (id_pedido, data) => {
    try {
      await api.put(`api/pedido-empaque/pedido_empaque/${id_pedido}/`, data, {
        headers: {
          Authorization: "Token " + token,
        },
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  return {
    getPedidoEmpaque,
    saveEmpaque,
    retrivePedido,
    destroyPedido,
    editPedido,
  };
};
